/**
 * @generated SignedSource<<df9b168dcf060f37d3a88f2b4310fd63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarTeamScreenComponent_team$data = {
  readonly calendarEvents: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly createdAt: {
          readonly isoString: string;
        };
        readonly endAt: {
          readonly isoString: string;
        };
        readonly id: string;
        readonly isAllDayEvent: boolean;
        readonly startAt: {
          readonly isoString: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventItem_event">;
      };
    }>;
  } | null;
  readonly calendars: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly id: string;
  readonly " $fragmentType": "CalendarTeamScreenComponent_team";
};
export type CalendarTeamScreenComponent_team$key = {
  readonly " $data"?: CalendarTeamScreenComponent_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamScreenComponent_team">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "calendarEvents"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isoString",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./CalendarTeamScreenComponentPaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "CalendarTeamScreenComponent_team",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeExternal",
          "value": false
        }
      ],
      "concreteType": "StoreCalendar",
      "kind": "LinkedField",
      "name": "calendars",
      "plural": true,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": "calendars(includeExternal:false)"
    },
    {
      "alias": "calendarEvents",
      "args": null,
      "concreteType": "CalendarTeamCalendarEventsConnection",
      "kind": "LinkedField",
      "name": "__CalendarTeamScreenComponent_calendarEvents_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CalendarTeamCalendarEventsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CalendarEvent",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreZonedDate",
                  "kind": "LinkedField",
                  "name": "startAt",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreZonedDate",
                  "kind": "LinkedField",
                  "name": "endAt",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreZonedDate",
                  "kind": "LinkedField",
                  "name": "createdAt",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isAllDayEvent",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CalendarTeamEventItem_event"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "abace2d3185d302e9386d6d141dbfc0f";

export default node;
